import React from 'react'
import styles from "./maintenancePage.module.css"
import BrandLogo from "../assets/BlackLogo.png"
import MaitenanceLogo from "../assets/MaitenanceLogo.png"


const MaintenancePage = () => {
  return (
    <div className={styles.mainContainer}>
        <div className={styles.subContainer}>
            <img src={BrandLogo} className={styles.brandLogo} alt="BrandIt3D" />
            <h1>Systemunderhåll pågår</h1>
            <p>Vi arbetar just nu med förbättringar och uppdateringar av systemet. <br/><br /> Tjänsten är tillfälligt otillgänglig men kommer snart vara tillbaka. <br/><br/>Tack för ert tålamod!</p>
            <img src={MaitenanceLogo} className={styles.maintenanceLogo} alt="Underhåll pågår" />
            <p>Beräknat i drift igen: 2026-05-18</p>
        </div>
    </div>
  )
}

export default MaintenancePage
